import { render, staticRenderFns } from "./FormControlProductVariablesOptionId.vue?vue&type=template&id=c9be300c&scoped=true"
import script from "./FormControlProductVariablesOptionId.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlProductVariablesOptionId.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlProductVariablesOptionId.vue?vue&type=style&index=0&id=c9be300c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9be300c",
  null
  
)

export default component.exports